import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { CustomerSelectComponent } from '@shared-feature/components/select/customer-select/customer-select.component';

@Component({
  selector: 'app-customer-range',
  templateUrl: './customer-range.component.html',
  standalone: false
})
export class CustomerRangeComponent {
  @ViewChild('toSelect') toSelect!: CustomerSelectComponent;
  @ViewChild('fromSelect') fromSelect!: CustomerSelectComponent;
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
